const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLearning03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1332 1000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,993.277c0,-0 0,-763.197 0,-951.61c0,-11.051 4.39,-21.649 12.204,-29.463c7.814,-7.814 18.412,-12.204 29.463,-12.204c198.977,0 1051.02,0 1250,0c11.05,-0 21.648,4.39 29.462,12.204c7.814,7.814 12.204,18.412 12.204,29.463c0,188.413 0,951.61 0,951.61l-1333.33,-0Z",
    style: {
      fill: "#b5c19d",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.667,914.501c-215.308,-0 -389.849,-11.75 -389.849,-26.249c-0,-14.5 174.541,-26.254 389.849,-26.254c215.31,-0 389.848,11.754 389.848,26.254c0,14.499 -174.538,26.249 -389.848,26.249Z",
    style: {
      fill: "#d6a95b",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.904,897.725l-637.2,0c-22.226,0 -40.245,-17.901 -40.245,-39.982l0,-19.988l717.693,-0l-0,19.988c-0,22.081 -18.021,39.982 -40.248,39.982Z",
    style: {
      fill: "#62a0c2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.719,865.074l-136.829,-0c-15.187,-0 -27.501,-12.233 -27.501,-27.319l191.831,-0c-0,15.086 -12.314,27.319 -27.501,27.319Z",
    style: {
      fill: "#bde2f5",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.868,837.755l-625.127,-0l-0,-333.152c-0,-29.439 24.023,-53.307 53.659,-53.307l517.811,0c29.635,0 53.657,23.868 53.657,53.307l0,333.152Z",
    style: {
      fill: "#8fc3e1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.918,504.603l0,286.512l-531.226,-0l0,-286.512c0,-3.673 3.012,-6.663 6.708,-6.663l517.811,-0c3.697,-0 6.707,2.99 6.707,6.663Z",
    style: {
      fill: "#e9f7fe",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 637.004,
    y: 462.891,
    width: 57.092,
    height: 56.457,
    style: {
      fill: "#fdd4b5",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.807,462.887l-48.817,52.931l0.014,-52.927l48.803,-0.004Z",
    style: {
      fill: "#eac2a6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.917,385.23c-0.091,0 -0.176,0.005 -0.267,0.007l0,31.262c0.091,0.001 0.176,0.007 0.267,0.007c8.694,-0 15.744,-7.001 15.744,-15.638c-0,-8.637 -7.05,-15.638 -15.744,-15.638Z",
    style: {
      fill: "#fdd4b5",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.916,385.23c0.09,0 0.181,0.005 0.267,0.007l-0,31.262c-0.086,0.001 -0.177,0.007 -0.267,0.007c-8.694,-0 -15.739,-7.001 -15.739,-15.638c-0,-8.637 7.045,-15.638 15.739,-15.638Z",
    style: {
      fill: "#fdd4b5",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.917,378.074l-0,36.047c-0,1.528 -0.057,3.042 -0.167,4.542l0,0.003c-0.076,1.011 -0.176,2.016 -0.3,3.014c-3.749,30.101 -29.587,53.399 -60.898,53.399c-31.568,-0 -57.568,-23.672 -60.988,-54.122c-0.11,-0.982 -0.196,-1.975 -0.257,-2.973c-0.081,-1.277 -0.124,-2.564 -0.124,-3.863l-0,-36.047c-0,-33.668 27.476,-60.961 61.369,-60.961c16.944,0 32.283,6.824 43.392,17.855c11.104,11.033 17.973,26.272 17.973,43.106Z",
    style: {
      fill: "#fdd4b5",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.228,382.79c-0.333,1.242 -0.686,2.497 -1.057,3.772l-0,0.003c-1.196,4.13 -2.568,8.411 -4.121,12.846c0,-0 -0.205,-3.135 -0.833,-7.861c-0.1,-0.751 -0.21,-1.546 -0.334,-2.373c-2.039,-13.715 -7.302,-36.79 -19.912,-40.657c-16.887,-5.182 -24.923,14.213 -70.706,0c-12.38,-3.841 -22.236,6.153 -30.225,39.845c-0.176,0.723 -0.343,1.455 -0.514,2.196c-0.115,0.508 -0.229,1.018 -0.343,1.534c-0,0 -0.805,-1.29 -1.949,-3.844c-0.547,-1.227 -1.176,-2.745 -1.829,-4.552c-3.144,-8.716 -6.893,-24.161 -5.426,-46.047c1.201,-17.889 18.012,-37.502 40.286,-30.745c0,0 30.287,-24.782 66.705,-10.336c32.159,12.755 42.815,39.683 30.258,86.219Z",
    style: {
      fill: "#3464a8",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.354,448.777l-18.868,23.922l16.477,-38.469c0.777,-12.355 -9.737,-4.88 -9.737,-4.88l-17.696,37.253c-0,-0 10.298,-28.525 11.87,-45.028c1.268,-13.322 -9.489,-6.576 -9.489,-6.576l-16.515,48.161l6.474,-36.808c-6.141,-14.08 -13.419,1.164 -13.419,1.164l-11.647,50.601l-3.345,-19.881c-6.068,-8.503 -12.918,-2.227 -12.918,-2.227l4.263,34.908c-6.202,11.618 -5.045,23.798 -2.301,33.135l32.988,15.9c31.102,-27.319 32.426,-43.881 38.371,-56.303c7.16,-14.956 16.011,-25.557 16.196,-27.08c1.505,-12.595 -10.704,-7.792 -10.704,-7.792Z",
    style: {
      fill: "#fdd4b5",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.918,445.335l19.08,24.56l-16.533,-39.392c-0.699,-12.617 9.978,-4.909 9.978,-4.909l17.783,38.159c0,0 -10.299,-29.194 -11.777,-46.052c-1.193,-13.609 9.737,-6.642 9.737,-6.642l16.495,49.286l-6.331,-37.622c6.375,-14.327 13.69,1.288 13.69,1.288l11.506,51.74l3.564,-20.269c6.257,-8.634 13.205,-2.177 13.205,-2.177l-4.617,35.601c6.244,11.911 4.972,24.333 2.098,33.844l-33.793,15.981c-31.544,-28.119 -32.767,-45.031 -38.743,-57.756c-7.195,-15.322 -16.153,-26.209 -16.328,-27.766c-1.445,-12.868 10.986,-7.874 10.986,-7.874Z",
    style: {
      fill: "#fdd4b5",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.896,517.124c-0.086,0.293 -8.551,29.382 -21.893,59.147c-18.498,41.259 -31.807,51.845 -35.842,54.259c-4.501,-3.019 -15.367,-14.836 -28.562,-45.557c-10.576,-24.621 -17.025,-48.253 -17.083,-48.471c0,-0 -0.633,-2.854 -1.01,-3.748c-0.381,-0.894 -1.991,-3.341 -1.991,-3.341c-1.324,-2.229 -6.316,-9.862 -15.634,-16.444c-13.205,-8.376 -26.919,-12.947 -38.133,-15.029c-14.233,-2.646 -24.427,-1.874 -24.427,-1.874c-0,-0 -0.839,0.762 -2.411,1.874c-0.247,0.18 -0.524,0.374 -0.81,0.563c-4.906,3.341 -15.086,8.844 -28.124,8.352c-13.038,0.492 -23.218,-5.011 -28.124,-8.352c-0.291,-0.189 -0.562,-0.383 -0.81,-0.563c-1.572,-1.112 -2.41,-1.874 -2.41,-1.874c-0,-0 -10.194,-0.772 -24.428,1.874c-11.214,2.082 -24.928,6.653 -38.133,15.029c-9.322,6.582 -14.31,14.215 -15.639,16.444c0,0 -1.61,2.447 -1.986,3.341c-0.376,0.894 -1.01,3.748 -1.01,3.748c-0.062,0.218 -6.507,23.85 -17.082,48.471c-13.195,30.721 -24.061,42.538 -28.563,45.557c-4.035,-2.414 -17.349,-13 -35.843,-54.259c-13.343,-29.765 -21.809,-58.854 -21.893,-59.147l-54.807,15.602c0.387,1.344 9.661,33.309 24.799,66.988c9.234,20.542 18.829,37.616 28.514,50.747c15.023,20.368 30.739,32.136 48.045,35.988c3.425,0.762 7.274,1.269 11.442,1.269c13.329,-0 29.987,-5.168 46.874,-23.685c4.659,-5.11 9.251,-11.177 13.748,-18.143l-6.502,145.225l207.617,-0l-6.507,-145.225c4.501,6.966 9.093,13.033 13.752,18.143c16.887,18.517 33.541,23.685 46.869,23.685c4.173,-0 8.022,-0.507 11.447,-1.269c17.306,-3.852 33.021,-15.62 48.046,-35.988c9.684,-13.131 19.278,-30.205 28.515,-50.747c15.134,-33.679 24.409,-65.644 24.794,-66.988l-54.805,-15.602Z",
    style: {
      fill: "#7fa2d4",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.502,493.941l-31.526,12.659l18.778,15.989l36.223,-25.317l-23.475,-3.331Z",
    style: {
      fill: "#527fbd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.95,497.272l27.501,-3.331l31.525,12.659l-18.783,15.989l-40.243,-25.317Z",
    style: {
      fill: "#527fbd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.327,522.627l18.649,-16.027l18.778,15.989l-2.558,14.112l-32.149,-0l-2.72,-14.074Z",
    style: {
      fill: "#bde2f5",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.047,536.701l-10.352,182.405l28.877,27.063l29.425,-28.147l-15.801,-181.321l-32.149,-0Z",
    style: {
      fill: "#e9f7fe",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.162,235.128l-200.773,-0c-6.849,-0 -12.401,-5.516 -12.401,-12.32l-0,-121.133c-0,-6.804 5.552,-12.32 12.401,-12.32l200.773,-0c6.845,-0 12.4,5.516 12.4,12.32l-0,121.133c-0,6.804 -5.555,12.32 -12.4,12.32Zm-182.852,-26.258l-0,2.366l166.479,0l0,-0.161c0.582,-0.073 1.034,-0.568 1.039,-1.169l0.305,-86.914c-0,-0.654 -0.529,-1.185 -1.186,-1.188l-0.005,0c-0.658,0 -1.191,0.528 -1.191,1.179l-0.3,85.887l-165.141,-0Zm118.739,-41.53l32.335,30.593c0.233,0.218 0.529,0.326 0.824,0.326c0.314,-0 0.629,-0.123 0.862,-0.367c0.453,-0.473 0.434,-1.222 -0.043,-1.673l-32.249,-30.513l32.097,-30.395c0.476,-0.45 0.495,-1.199 0.043,-1.672c-0.234,-0.244 -0.548,-0.367 -0.862,-0.367c-0.296,-0 -0.591,0.108 -0.825,0.327l-32.182,30.473l-5.427,-5.132l-4.191,7.667l-11.465,-9.565l-16.648,14.387l-19.181,-17.18l-21.509,-0.151l-28.865,-19.416c-0.205,-0.137 -0.437,-0.202 -0.667,-0.202c-0.382,-0 -0.757,0.182 -0.987,0.519c-0.369,0.541 -0.227,1.276 0.318,1.643l29.463,19.817l21.325,0.15l18.293,16.385l-11.975,10.35l-20.87,-15.023l-36.235,24.304c-0.545,0.365 -0.688,1.101 -0.32,1.642c0.23,0.339 0.605,0.522 0.988,0.522c0.229,-0 0.461,-0.067 0.665,-0.203l34.853,-23.378l21.054,15.155l13.622,-11.773l17.774,15.92l11.067,-20.228l3.087,2.578l5.831,-5.52Zm-20.635,19.402l-15.314,-13.716l14.893,-12.871l10.275,8.574l-9.854,18.013Zm14.704,-17.056l-1.829,-1.525l2.944,-5.378l3.091,2.923l-4.206,3.98Z",
    style: {
      fill: "#f0e8cf",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.789,211.236l-166.479,0l-0,-2.366l165.141,-0l-0.005,1.028c-0.005,0.653 0.529,1.185 1.186,1.187l0.005,0c0.052,0 0.1,-0.003 0.152,-0.01l0,0.161Z",
    style: {
      fill: "#738394",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.637,211.085l-0.005,0c-0.657,-0.002 -1.191,-0.534 -1.186,-1.187l0.005,-1.028l0.3,-85.887c-0,-0.651 0.533,-1.179 1.191,-1.179l0.005,0c0.657,0.003 1.186,0.534 1.186,1.188l-0.305,86.914c-0.005,0.601 -0.457,1.096 -1.039,1.169c-0.052,0.007 -0.1,0.01 -0.152,0.01Z",
    style: {
      fill: "#738394",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.096,194.789c-0.383,-0 -0.758,-0.183 -0.988,-0.522c-0.368,-0.541 -0.225,-1.277 0.32,-1.642l36.235,-24.304l20.87,15.023l11.975,-10.35l1.782,1.596l-13.622,11.773l-21.054,-15.155l-34.853,23.378c-0.204,0.136 -0.436,0.203 -0.665,0.203Zm72.004,-21.763l-1.782,-1.597l16.648,-14.387l11.465,9.565l-1.163,2.122l-10.275,-8.574l-14.893,12.871Zm30.118,-0.166l-3.087,-2.578l1.158,-2.121l1.829,1.525l4.206,-3.98l1.725,1.634l-5.831,5.52Zm7.56,-7.154l-1.729,-1.634l32.182,-30.473c0.234,-0.219 0.529,-0.327 0.825,-0.327c0.314,-0 0.628,0.123 0.862,0.367c0.452,0.473 0.433,1.222 -0.043,1.672l-32.097,30.395Z",
    style: {
      fill: "#738394",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.208,198.259c-0.295,-0 -0.591,-0.108 -0.824,-0.326l-32.335,-30.593l-1.725,-1.634l-3.091,-2.923l-2.944,5.378l-1.158,2.121l-11.067,20.228l-17.774,-15.92l-1.782,-1.596l-18.293,-16.385l-21.325,-0.15l-29.463,-19.817c-0.545,-0.367 -0.687,-1.102 -0.318,-1.643c0.23,-0.337 0.605,-0.519 0.987,-0.519c0.23,-0 0.462,0.065 0.667,0.202l28.865,19.416l21.509,0.151l19.181,17.18l1.782,1.597l15.314,13.716l9.854,-18.013l1.163,-2.122l4.191,-7.667l5.427,5.132l1.729,1.634l32.249,30.513c0.477,0.451 0.496,1.2 0.043,1.673c-0.233,0.244 -0.548,0.367 -0.862,0.367Z",
    style: {
      fill: "#f6ab28",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.5,504.508l-200.771,-0c-6.85,-0 -12.405,-5.518 -12.405,-12.318l0,-121.135c0,-6.804 5.555,-12.32 12.405,-12.32l200.771,-0c6.846,-0 12.4,5.516 12.4,12.32l0,121.135c0,6.8 -5.554,12.318 -12.4,12.318Zm-185.104,-27.465c-0.095,0.17 -0.152,0.369 -0.152,0.577c-0,0.658 0.533,1.188 1.191,1.188l168.608,-0c0.657,-0 1.19,-0.53 1.19,-1.188c0,-0.653 -0.533,-1.178 -1.19,-1.178l-22.137,-0l-35.284,-78.491l-26.943,70.663l-19.535,-49.538l-18.093,46.484l-14.414,-29.282l-20.065,40.164l-10.794,-0l0,-88.299l-2.382,-0l0,88.9Z",
    style: {
      fill: "#f0e8cf",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.4,477.043l0,-88.9l2.382,-0l0,88.299l-1.343,-0c-0.443,-0 -0.834,0.241 -1.039,0.601Z",
    style: {
      fill: "#738394",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1107.82,476.442l-30.249,-0l20.065,-40.164l14.414,29.282l-4.23,10.882Z",
    style: {
      fill: "#fed865",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.7,476.442l-38.876,-0l4.23,-10.882l18.093,-46.484l19.535,49.538l-2.982,7.828Z",
    style: {
      fill: "#f5c528",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1211.91,476.442l-65.209,-0l2.982,-7.828l26.943,-70.663l35.284,78.491Z",
    style: {
      fill: "#cd8f2b",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1234.05,478.808l-168.608,-0c-0.658,-0 -1.191,-0.53 -1.191,-1.188c-0,-0.208 0.057,-0.407 0.152,-0.577c0.205,-0.36 0.596,-0.601 1.039,-0.601l168.608,-0c0.657,-0 1.19,0.525 1.19,1.178c0,0.658 -0.533,1.188 -1.19,1.188Z",
    style: {
      fill: "#738394",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.308,503.793l-198.799,0c-6.782,0 -12.28,-5.461 -12.28,-12.199l-0,-119.944c-0,-6.737 5.498,-12.199 12.28,-12.199l198.799,-0c6.782,-0 12.28,5.462 12.28,12.199l-0,119.944c-0,6.738 -5.498,12.199 -12.28,12.199Zm-201.052,-24.048l0,4.732l204.484,-0l0,-4.732l-14.353,-0l-0,-106.622l-28.903,0l-0,106.622l-18.286,-0l0,-85.137l-28.902,0l-0,85.137l-16.32,-0l-0,-61.698l-28.903,-0l0,61.698l-18.286,-0l0,-48.026l-28.903,0l0,48.026l-21.628,-0Z",
    style: {
      fill: "#f0e8cf",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.884,
    y: 452.033,
    width: 28.903,
    height: 27.712,
    style: {
      fill: "#a7adb3",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.884,
    y: 431.719,
    width: 28.903,
    height: 20.314,
    style: {
      fill: "#fdbb4d",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.073,
    y: 438.36,
    width: 28.903,
    height: 41.385,
    style: {
      fill: "#a7adb3",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.073,
    y: 418.047,
    width: 28.903,
    height: 20.313,
    style: {
      fill: "#fdbb4d",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.296,
    y: 414.922,
    width: 28.903,
    height: 64.823,
    style: {
      fill: "#a7adb3",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.296,
    y: 394.608,
    width: 28.903,
    height: 20.314,
    style: {
      fill: "#fdbb4d",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.484,
    y: 393.436,
    width: 28.903,
    height: 86.308,
    style: {
      fill: "#a7adb3",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.484,
    y: 373.123,
    width: 28.903,
    height: 20.313,
    style: {
      fill: "#fdbb4d",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.74,484.477l-204.484,-0l0,-4.732l204.484,-0l0,4.732Z",
    style: {
      fill: "#738394",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.257,234.412l-198.799,0c-6.784,0 -12.281,-5.461 -12.281,-12.199l0,-119.943c0,-6.737 5.497,-12.199 12.281,-12.199l198.799,-0c6.779,-0 12.281,5.462 12.281,12.199l-0,119.943c-0,6.738 -5.502,12.199 -12.281,12.199Zm-139.707,-73.065l-37.122,33.868c9.212,9.96 22.431,16.205 37.122,16.205c13.172,-0 25.162,-5.021 34.141,-13.238c9.999,-9.15 16.263,-22.265 16.263,-36.835c0,-0.311 -0.005,-0.621 -0.009,-0.931l-50.395,0.931Zm106.21,41.77l25.461,-0c2.553,-0 4.63,-2.059 4.63,-4.598l0,-7.409c0,-2.54 -2.077,-4.599 -4.63,-4.599l-25.461,0l-0,16.606Zm-16.201,-16.606l-0,16.606l16.201,-0l-0,-16.606l-16.201,0Zm-11.057,0c-2.558,0 -4.63,2.059 -4.63,4.599l0,7.409c0,2.539 2.072,4.598 4.63,4.598l11.057,-0l-0,-16.606l-11.057,0Zm-78.952,-75.236c-27.838,-0 -50.408,22.418 -50.408,50.072c-0,13.062 5.035,24.953 13.286,33.868l37.122,-33.868l50.395,-0.931c-0.505,-27.224 -22.871,-49.141 -50.395,-49.141Zm116.499,40.747l0,16.607l15.172,-0c2.553,-0 4.63,-2.059 4.63,-4.599l0,-7.409c0,-2.54 -2.077,-4.599 -4.63,-4.599l-15.172,0Zm-37.037,16.607l37.037,-0l0,-16.607l-37.037,0c-2.839,0 -5.14,2.059 -5.14,4.599l0,7.409c0,2.54 2.301,4.599 5.14,4.599Zm26.748,-34.489l24.218,-0c3.101,-0 5.611,-2.059 5.611,-4.599l0,-7.409c0,-2.539 -2.51,-4.598 -5.611,-4.598l-24.218,-0l-0,16.606Zm-26.776,-0l26.776,-0l-0,-16.606l-26.776,-0c-2.968,-0 -5.369,2.059 -5.369,4.598l-0,7.409c-0,2.54 2.401,4.599 5.369,4.599Z",
    style: {
      fill: "#f0e8cf",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.428,195.215c-8.251,-8.915 -13.286,-20.806 -13.286,-33.868c-0,-27.654 22.57,-50.072 50.408,-50.072c27.524,-0 49.89,21.917 50.395,49.141l-50.395,0.931l-37.122,33.868Z",
    style: {
      fill: "#f6ab28",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.55,211.42c-14.691,-0 -27.91,-6.245 -37.122,-16.205l37.122,-33.868l34.141,36.835c-8.979,8.217 -20.969,13.238 -34.141,13.238Z",
    style: {
      fill: "#fdbb4d",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.691,198.182l-34.141,-36.835l50.395,-0.931c0.004,0.31 0.009,0.62 0.009,0.931c0,14.57 -6.264,27.685 -16.263,36.835Z",
    style: {
      fill: "#fec766",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.049,168.629l-21.603,-0l0,-16.607l-2.058,0l23.661,0l0,16.607Z",
    style: {
      fill: "#8894a1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.446,168.629l-15.434,-0c-2.839,-0 -5.14,-2.059 -5.14,-4.599l0,-7.409c0,-2.54 2.301,-4.599 5.14,-4.599l15.434,0l0,16.607Z",
    style: {
      fill: "#738394",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.221,168.629l-15.172,-0l0,-16.607l15.172,0c2.553,0 4.63,2.059 4.63,4.599l0,7.409c0,2.54 -2.077,4.599 -4.63,4.599Z",
    style: {
      fill: "#a7adb3",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.221,203.117l-9.518,-0l0,-16.606l9.518,0c2.553,0 4.63,2.059 4.63,4.599l0,7.409c0,2.539 -2.077,4.598 -4.63,4.598Z",
    style: {
      fill: "#a7adb3",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.559,203.117l-11.057,-0c-2.558,-0 -4.63,-2.059 -4.63,-4.598l0,-7.409c0,-2.54 2.072,-4.599 4.63,-4.599l11.057,0l-0,16.606Z",
    style: {
      fill: "#a7adb3",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 910.559,
    y: 186.511,
    width: 16.201,
    height: 16.606,
    style: {
      fill: "#738394",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 926.76,
    y: 186.511,
    width: 15.944,
    height: 16.606,
    style: {
      fill: "#8894a1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.76,134.14l-17.23,-0l-0,-16.606l-2.058,-0l19.288,-0l-0,16.606Z",
    style: {
      fill: "#8894a1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.53,134.14l-9.546,-0c-2.968,-0 -5.369,-2.059 -5.369,-4.599l-0,-7.409c-0,-2.539 2.401,-4.598 5.369,-4.598l9.546,-0l-0,16.606Z",
    style: {
      fill: "#d0d8c8",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.932,134.14l-15.172,-0l-0,-16.606l17.744,-0l-2.572,-0l-0,16.606Z",
    style: {
      fill: "#738394",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.978,134.14l-9.046,-0l-0,-16.606l9.046,-0c3.101,-0 5.611,2.059 5.611,4.598l0,7.409c0,2.54 -2.51,4.599 -5.611,4.599Z",
    style: {
      fill: "#a7adb3",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearning03);
export default __webpack_public_path__ + "static/media/learning-03.e6b6754327e7379ea6f628bbd736e0d7.svg";
export { ForwardRef as ReactComponent };